export type FaqQuestion = {
  title: string;
  content: string;
  id?: string;
};

export type FaqCategoryId = "general" | "investors" | "borrowers";

export type FaqCategory = {
  id: FaqCategoryId;
  label: string;
  heading: string;
  questions: Array<FaqQuestion>;
};

const generalQuestions: Array<FaqQuestion> = [
  {
    title: "Что такое инвестиционная платформа?",
    content: `
      <p>Инвестиционная платформа – это информационная система (автоматизированный программно-технический комплекс), предназначенная для заключения и сопровождения сделок по привлечению инвестиций между инвесторами и лицами, привлекающими финансирование.</p>
      <p>С использованием инвестиционной платформы несколько инвесторов могут объединять свои средства и предоставлять финансирование бизнесу на условиях, зафиксированных в инвестиционном предложении.</p>
      <p>Инвесторы и лица, привлекающие финансирование, заключают прямые гражданско-правовые сделки между собой. Платформа не является стороной таких сделок и не предоставляет финансирование от своего имени.</p>
      <p>Функции инвестиционной платформы включают:</p>
      <ul>
        <li>организацию и техническое обеспечение заключения сделок;</li>
        <li>проведение скоринговой и юридической оценки проектов;</li>
        <li>ведение электронного документооборота;</li>
        <li>учёт обязательств сторон;</li>
        <li>администрирование расчётов и мониторинг исполнения сделок;</li>
        <li>обеспечение прозрачного и безопасного порядка взаиморасчётов.</li>
      </ul>
      <p>Деятельность инвестиционных платформ осуществляется в соответствии с Федеральным законом № 259-ФЗ от 02.08.2019 года «О привлечении инвестиций с использованием инвестиционных платформ и о внесении изменений в отдельные законодательные акты Российской Федерации» и подлежит регулированию со стороны Банка России.</p>
    `,
  },
  {
    title: "Привлекает ли Платформа денежные средства и инвестирует ли их от своего имени?",
    content: `
      <p>Нет.</p>
      <p>Инвестиционная платформа не привлекает денежные средства от пользователей и не инвестирует от своего имени.</p>
      <p>Платформа:</p>
      <ul>
        <li>предоставляет техническую возможность заключения сделки между инвестором и заёмщиком;</li>
        <li>ведёт учёт обязательств;</li>
        <li>администрирует расчёты и исполнение сделок.</li>
      </ul>
      <p>Денежные средства предоставляются инвесторами напрямую заёмщикам, а не Платформе.</p>
    `,
  },
  {
    title: "В чём особенность Платформы «Кономика-займы»?",
    content: `
      <p>Платформа «Кономика-займы» – это продукт Группы компаний «Кономика», одного из крупнейших участников рынка коммерческой дебиторской задолженности в России.</p>
      <p>Платформа объединяет более 9 лет практического опыта Группы в:</p>
      <ul>
        <li>оценке дебиторской задолженности;</li>
        <li>юридическом сопровождении и взыскании коммерческих долгов;</li>
        <li>структурировании сделок с требованиями к контрагентам.</li>
      </ul>
      <p>В Группу «Кономика» входят:</p>
      <p>Технологии скоринга (бренд Rescore) – компания, специализирующаяся на анализе и оценке платёжеспособности контрагентов;</p>
      <p>Про Фактор – юридическая компания с многолетним опытом взыскания коммерческой задолженности, с портфелем сотен арбитражных дел;</p>
      <p>Онлайн-сервис «Кономика» – CRM-система для сопровождения сделок с дебиторской задолженностью.</p>
      <p>Оператором Платформы является ООО «Кономика-займы для бизнеса», включённое в Реестр операторов инвестиционных платформ Банка России.</p>
    `,
  },
  {
    title: "В чём суть сделок, заключаемых на Платформе?",
    content: `
      <p>Платформа «Кономика-займы» использует модель финансирования бизнеса под текущую дебиторскую задолженность.</p>
      <p>В рамках сделки:</p>
      <ul>
        <li>инвесторы предоставляют денежные средства по договору инвестирования;</li>
        <li>заёмщик получает финансирование;</li>
        <li>в качестве обеспечения используются права требования к дебиторам заёмщика.</li>
      </ul>
      <p>Обеспечением может выступать исключительно текущая (непросроченная) дебиторская задолженность.</p>
      <p>Юридически конструкция сделки включает:</p>
      <ul>
        <li>договор инвестирования (займа);</li>
        <li>договоры обеспечительного характера (уступка прав требования или залог прав требования).</li>
      </ul>
      <p>Погашение займа может осуществляться:</p>
      <ul>
        <li>самим заёмщиком;</li>
        <li>либо его дебиторами, путём перечисления средств на счёт Платформы.</li>
      </ul>
      <p>Все поступающие средства зачисляются на номинальный счёт Платформы и распределяются между участниками сделки в соответствии с условиями сделки и данными учётной системой Платформы.</p>
    `,
  },
  {
    title: "Платформа оценивает платёжеспособность заёмщика и обеспечение?",
    content: `
      <p>Да.</p>
      <p>Платформа проводит комплексную оценку сделки, включая:</p>
      <ul>
        <li>платёжеспособность заёмщика;</li>
        <li>платёжеспособность дебиторов;</li>
        <li>правовую устойчивость и основание возникновения требований к дебиторам.</li>
      </ul>
    `,
  },
  {
    title: "Как происходит сделка на Платформе?",
    content: `
      <p>1. Заёмщик размещает заявку в личном кабинете.</p>
      <p>2. Платформа проводит скоринговую и юридическую оценку.</p>
      <p>3. После одобрения предложение публикуется на Платформе.</p>
      <p>4. Инвесторы подтверждают участие в сделке через личные кабинеты.</p>
      <p>5. Сделка финансируется по принципу софинансирования – несколькими инвесторами.</p>
      <p>6. После достижения целевой суммы Платформа оформляет сделку.</p>
      <p>7. Заёмщик получает средства на расчётный счёт.</p>
      <p>8. Платформа администрирует погашение и расчёты.</p>
      <p>Вся информация по сделке отображается в личных кабинетах пользователей.</p>
    `,
  },
  {
    title: "Как технически происходит возврат средств?",
    content: `
      <p>Независимо от того, кто исполняет обязательство (заёмщик или дебитор), все платежи поступают на номинальный счёт Платформы.</p>
      <p>Учётная система Платформы:</p>
      <ul>
        <li>идентифицирует сделку;</li>
        <li>распределяет средства между участниками в соответствии с реестром прав.</li>
      </ul>
    `,
  },
  {
    title: "Что такое номинальный счёт?",
    content: `
      <p>Номинальный счёт – это специальный банковский счёт для учёта средств третьих лиц.</p>
      <p>Средства на таком счёте:</p>
      <ul>
        <li>отделены от собственных средств Платформы;</li>
        <li>не используются для её хозяйственной деятельности;</li>
        <li>не подлежат взысканию по обязательствам Платформы;</li>
        <li>списываются строго в интересах владельцев средств.</li>
      </ul>
    `,
  },
  {
    title: "Кто может быть клиентом Платформы?",
    content: `
      <p>Заёмщики – юридические лица.</p>
      <p>Инвесторы – юридические лица, индивидуальные предприниматели и физические лица.</p>
    `,
  },
  {
    title: "В чём преимущества Платформы для клиентов?",
    content: `
      <p>Платформа предоставляет доступ к инструментам финансирования под дебиторскую задолженность, которые ранее были доступны преимущественно банкам.</p>
      <p>Преимущества:</p>
      <ul>
        <li>финансирование под конкретную дебиторскую задолженность;</li>
        <li>возможность софинансирования несколькими инвесторами;</li>
        <li>снижение рисков за счёт диверсификации;</li>
        <li>формирование прозрачной кредитной истории заёмщика.</li>
      </ul>
    `,
  },
  {
    title: "На чём зарабатывает Платформа?",
    content: `
      <p>Услуги Платформы являются платными.</p>
      <p>Размер и порядок оплаты указаны в Правилах Платформы и разделе «Тарифы».</p>
    `,
  },
  {
    title: "Как стать клиентом Платформы?",
    content: `
      <p>Пройти электронную регистрацию;</p>
      <p>Заполнить верификационную анкету.</p>
    `,
  },
  {
    title: "Должен ли инвестор самостоятельно заниматься взысканием?",
    content: `
      <p>Нет.</p>
      <p>Все действия по администрированию сделки и взысканию задолженности осуществляет Платформа в соответствии с:</p>
      <ul>
        <li>Правилами Платформы;</li>
        <li>Регламентом работы с просроченной задолженностью;</li>
        <li>Правилами работы с договорами обеспечения.</li>
      </ul>
    `,
  },
];

const investorQuestions: Array<FaqQuestion> = [
  {
    title: "Кто может быть инвестором?",
    content: `
      <p>Инвесторами могут быть:</p>
      <ul>
        <li>юридические лица;</li>
        <li>индивидуальные предприниматели;</li>
        <li>физические лица, являющиеся налоговыми резидентами Российской Федерации.</li>
      </ul>
    `,
  },
  {
    title: "Есть ли риск в инвестировании?",
    content: `
      <p>Да. Любое инвестирование связано с риском.</p>
      <p>Платформа проводит тщательную юридическую и финансовую оценку сделок, однако не гарантирует отсутствие рисков и не несёт ответственности за возможные убытки инвесторов.</p>
    `,
  },
  {
    title: "Почему бизнесу выгодно предоставлять обеспечение по сделке?",
    content: `
      <p>Финансирование под дебиторскую задолженность позволяет бизнесу:</p>
      <ul>
        <li>оперативно закрывать кассовые разрывы;</li>
        <li>пополнять оборотный капитал;</li>
        <li>монетизировать уже возникшие требования к контрагентам.</li>
      </ul>
      <p>Для компаний сегмента МСП дебиторская задолженность часто является основным ликвидным активом, тогда как получение классического банковского кредита может быть затруднено из-за сроков, требований к балансу или залогам.</p>
    `,
  },
  {
    title: "Как Платформа проводит скоринг сделок?",
    content: `
      <p>Скоринг на Платформе «Кономика-займы» включает:</p>
      <ul>
        <li>оценку платёжеспособности лица, привлекающего финансирование;</li>
        <li>оценку платёжеспособности дебиторов;</li>
        <li>проверку правовой устойчивости договоров, из которых возникает требование.</li>
      </ul>
      <p>Скоринг проводится преимущественно в ручном режиме, по принципам банковского анализа, с минимальным использованием автоматических фильтров (только по явным стоп-факторам).</p>
      <p>Группа компаний «Кономика» имеет значительный практический опыт в оценке ликвидности дебиторской задолженности. За время работы Группы бизнесу было возвращено в оборот более 7 млрд рублей, текущий портфель требований в управлении составляет около 2,3 млрд рублей. В штате – профессиональные юристы, специализирующиеся на взыскании коммерческой задолженности.</p>
    `,
  },
  {
    title: "Как технически заключается сделка на Платформе?",
    content: `
      <p>1. Инвестор регистрируется и присоединяется к Правилам Платформы.</p>
      <p>2. Проходит верификацию.</p>
      <p>3. В личном кабинете получает доступ к карточкам сделок с параметрами и результатами проверки.</p>
      <p>4. Принимает решение и подтверждает участие, указывая желаемый объём инвестиций.</p>
      <p>5. Документооборот осуществляется в электронном виде и подтверждается электронной подписью, формируемой в Платформе.</p>
    `,
  },
  {
    title: "Как происходит передача средств заёмщику?",
    content: `
      <p>Инвестор переводит средства на номинальный счёт Платформы.</p>
      <p>После подписания всех необходимых договоров Платформа перечисляет средства с номинального счёта на расчётный счёт лица, привлекающего финансирование.</p>
    `,
  },
  {
    title: "Нужна ли квалифицированная электронная подпись?",
    content: `
      <p>Нет.</p>
      <p>Для работы на Платформе используется встроенная система простой электронной подписи.</p>
    `,
  },
  {
    title: "Где хранятся документы?",
    content: `
      <p>Все документы формируются в электронном виде, хранятся в Платформе и доступны в личном кабинете пользователя не менее 5 лет.</p>
    `,
  },
  {
    title: "Как защищены персональные данные?",
    content: `
      <p>Данные хранятся в программном комплексе Платформы.</p>
      <p>Обработка и хранение осуществляются в соответствии с ФЗ-152 «О персональных данных». Серверы расположены на территории Российской Федерации.</p>
    `,
  },
  {
    title: "В чём разница между регистрацией и верификацией?",
    content: `
      <p>Регистрация – ознакомительный доступ к Платформе.</p>
      <p>Верификация – обязательна для заключения сделок и включает:</p>
      <ul>
        <li>заполнение анкеты;</li>
        <li>идентификацию личности;</li>
        <li>присоединение к Правилам и Пользовательскому договору.</li>
      </ul>
    `,
  },
  {
    title: "Может ли Платформа отказать в доступе?",
    content: `
      <p>Верификация может быть отклонена, если:</p>
      <ul>
        <li>предоставлены недостоверные данные;</li>
        <li>пользователь не является налоговым резидентом РФ;</li>
        <li>пользователь несовершеннолетний;</li>
        <li>пользователь подпадает под ограничения законодательства (включая 115-ФЗ).</li>
      </ul>
    `,
  },
  {
    title: "Нужно ли платить налоги с дохода?",
    content: `
      <p>Да. Налогообложение осуществляется в соответствии с Налоговым кодексом РФ и зависит от статуса инвестора.</p>
      <p>Для физических лиц налоговым агентом является заёмщик.</p>
      <p>В личном кабинете доступны отчётные документы.</p>
    `,
  },
  {
    title: "Кто контролирует операции по номинальному счёту?",
    content: `
      <p>Контроль осуществляет банк, в котором открыт номинальный счёт.</p>
      <p>Каждый платёж проверяется на соответствие условиям договоров, поручениям инвесторов и требованиям законодательства.</p>
    `,
  },
  {
    title: "Можно ли проводить расчёты вне номинального счёта?",
    content: `
      <p>Нет. Все расчёты по сделкам на Платформе осуществляются исключительно через номинальный счёт.</p>
    `,
  },
  {
    title: "Распространяется ли система страхования вкладов на номинальный счёт?",
    content: `
      <p>Нет. Государственная система страхования вкладов на номинальные счета не распространяется.</p>
    `,
  },
];

const borrowerQuestions: Array<FaqQuestion> = [
  {
    title: "Кто может привлекать средства через Платформу?",
    content: `
      <p>Привлекать финансирование через Платформу «Кономика-займы» могут исключительно юридические лица, зарегистрированные и осуществляющие деятельность на территории Российской Федерации.</p>
    `,
  },
  {
    title: "По каким ставкам и на какой срок можно привлечь средства?",
    content: `
      <p>Платформа специализируется на финансировании под краткосрочную дебиторскую задолженность.</p>
      <p>Инвестиционная платформа не привлекает денежные средства от пользователей и не инвестирует от своего имени. Срок займа соответствует сроку оплаты обязательства вашим дебитором и, как правило, составляет от 1 до 4 месяцев.</p>
      <p>Процентная ставка рассчитывается в годовом выражении.</p>
      <p>Диапазон ставок – от 25% до 40% годовых.</p>
      <p>Конкретные условия зависят от:</p>
      <ul>
        <li>типа сделки (с регрессом или без регресса);</li>
        <li>вида и качества обеспечения;</li>
        <li>платёжеспособности дебитора и заёмщика.</li>
      </ul>
    `,
  },
  {
    title: "Какие виды обеспечения возможны на Платформе?",
    content: `
      <p>На Платформе применяются следующие виды обеспечения:</p>
      <ul>
        <li>обеспечительная уступка прав требования к дебитору (базовый и основной механизм);</li>
        <li>залог прав требования – в отдельных случаях, по результатам оценки сделки.</li>
      </ul>
    `,
  },
  {
    title: "Что такое обеспечительная уступка и как она работает?",
    content: `
      <p>Обеспечительная уступка – это форма финансирования, близкая по своей экономической сути к факторингу.</p>
      <p>В рамках обеспечительной уступки:</p>
      <ul>
        <li>лицо, привлекающее финансирование, уступает права требования к своему дебитору в качестве обеспечения обязательств по договору займа;</li>
        <li>дебитор направляет платежи на номинальный счёт Платформы;</li>
        <li>поступившие средства уменьшают обязательства заёмщика перед инвесторами.</li>
      </ul>
      <p>Распределение средств:</p>
      <ul>
        <li>если поступлений от дебитора достаточно для погашения обязательств перед инвесторами – оставшийся излишек передаётся заёмщику;</li>
        <li>если поступлений недостаточно:
          <ul>
            <li>при сделке с регрессом заёмщик обязан погасить оставшуюся часть обязательств;</li>
            <li>при сделке без регресса обязательства заёмщика прекращаются на условиях, предусмотренных договором (через механизм отступного).</li>
          </ul>
        </li>
      </ul>
    `,
  },
  {
    title: "Какие требования предъявляются к заёмщику?",
    content: `
      <p>Юридический статус</p>
      <ul>
        <li>юридическое лицо – резидент РФ;</li>
        <li>зарегистрировано и действует в соответствии с законодательством РФ.</li>
      </ul>
      <p>Деловая активность</p>
      <ul>
        <li>компания является действующей;</li>
        <li>не находится в стадии ликвидации;</li>
        <li>не находится в процедуре банкротства.</li>
      </ul>
      <p>Судебные и регуляторные риски</p>
      <ul>
        <li>отсутствие активных дел о банкротстве, в которых компания выступает ответчиком.</li>
      </ul>
      <p>Опыт деятельности</p>
      <ul>
        <li>срок ведения хозяйственной деятельности – не менее 2 лет.</li>
      </ul>
      <p>Финансовые показатели</p>
      <ul>
        <li>годовая выручка за последний завершённый отчётный период – не менее 50 млн рублей;</li>
        <li>по итогам последнего отчётного периода деятельность должна быть прибыльной.</li>
      </ul>
      <p>Характер бизнеса</p>
      <ul>
        <li>B2B-модель;</li>
        <li>устойчивый операционный цикл;</li>
        <li>наличие текущей дебиторской задолженности, пригодной для использования в качестве обеспечения.</li>
      </ul>
    `,
  },
  {
    title: "Какие требования предъявляются к дебиторской задолженности?",
    content: `
      <p>Для рассмотрения заявки дебиторская задолженность должна:</p>
      <ul>
        <li>быть денежной;</li>
        <li>подтверждаться договором и первичными документами (акты, УПД, накладные и т.п.);</li>
        <li>иметь текущий характер (не просроченная);</li>
        <li>принадлежать дебиторам – преимущественно юридическим лицам, резидентам РФ;</li>
        <li>не находиться в споре и не оспариваться дебитором;</li>
      </ul>
      <p>Окончательная пригодность задолженности определяется по результатам юридической и финансовой экспертизы.</p>
    `,
  },
  {
    title: "Какие документы необходимо предоставить для скоринга?",
    content: `
      <p>Полный перечень документов доступен в личном кабинете после регистрации.</p>
      <p>Базово требуется предоставить:</p>
      <ul>
        <li>бухгалтерскую (финансовую) отчётность за последний завершённый отчётный год и за последнюю отчётную дату;</li>
        <li>банковские выписки по основным расчётным счетам:
          <ul>
            <li>за текущий календарный год;</li>
            <li>за два предшествующих завершённых года;</li>
          </ul>
        </li>
        <li>расшифровку оборотно-сальдовой ведомости по счёту 62 за последние 12 месяцев;</li>
        <li>документы, подтверждающие возникновение дебиторской задолженности:
          <ul>
            <li>договор с дебитором;</li>
            <li>первичные документы;</li>
          </ul>
        </li>
        <li>согласие на получение кредитного отчёта из бюро кредитных историй (БКИ).</li>
      </ul>
    `,
  },
];

export const faqCategories: Array<FaqCategory> = [
  {
    id: "general",
    label: "Общие вопросы",
    heading: "Общие вопросы",
    questions: generalQuestions,
  },
  {
    id: "investors",
    label: "Инвесторам",
    heading: "Инвесторам",
    questions: investorQuestions,
  },
  {
    id: "borrowers",
    label: "Заемщикам",
    heading: "Заемщикам (лицам, привлекающим финансирование)",
    questions: borrowerQuestions,
  },
];

export const faqQuestionsTotal = faqCategories.reduce(
  (total, category) => total + category.questions.length,
  0
);
